import { useSyncExternalStore } from 'react';

// The "Join" in the site menu (components/Navbar.js), shown on a community's
// page to visitors who aren't members: the page (pages/CommunityHome.js)
// registers its own Join here, so the menu's Join does exactly the same —
// the sign-up route (and its A/B test and logging), or joining straight away
// when logged in. null when there's nothing to join.
let current = null;
const listeners = new Set();

export const setNavJoin = (join) => {
  current = join;
  listeners.forEach((l) => l());
};

export const useNavJoin = () => useSyncExternalStore(
  (l) => { listeners.add(l); return () => listeners.delete(l); },
  () => current,
  () => null,
);
